<template>
	<div class="dynamic">
		<baidu-map class="bm-view" :zoom="zoom" :center="center" @ready="handler" :scroll-wheel-zoom="true">
			<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
			<bm-info-window :position="{lng: 118.78458999755058, lat: 32.051142994424296}" :show="infoWindow.show">
			    <p>中国江苏省南京市鼓楼区大锏银巷17号艺术金陵产业园博萃楼</p>
			</bm-info-window>
		</baidu-map>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				zoom: 17,
				center: {
					lng: 0,
					lat: 0
				},
				infoWindow: {
					show: true,
				    contents: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
				}
			}
		},
		methods: {
			handler({BMap,map}) {
				this.center.lng = 118.7897999755058
				this.center.lat = 32.049142
				this.zoom= 17
			}
		}
	}
</script>

<style scoped>
	.bm-view {
		height: 500px;
	}
</style>



// WEBPACK FOOTER //
// src/components/baiduMap.vue